import { ComponentProps, ReactElement } from 'react';

import Table from '@/common/Table';
import { formatNumber } from '@/utils';
import { getClasses } from '@/utils';

export type CustomPdfTableRowProps = CustomPdfChargeRowProps & CustomPdfSubtotalRowProps;

const CustomPdfTableRow = ({ index, type, note, cost, subtotal, ...props }: CustomPdfTableRowProps): ReactElement =>
  subtotal !== undefined ? (
    <CustomPdfSubtotalRow index={index} subtotal={subtotal} {...props} />
  ) : (
    <CustomPdfChargeRow index={index} type={type} note={note} cost={cost} {...props} />
  );

export type CustomPdfChargeRowProps = ComponentProps<typeof Table.Row> & {
  index?: number;
  type?: string;
  note?: string;
  cost?: number;
};

const CustomPdfChargeRow = ({ index, type, note, cost, ...props }: CustomPdfChargeRowProps): ReactElement => (
  <Table.Row {...props} className={getClasses('CustomPdfTable-Row', props.className)}>
    <Table.Cell className="INDEX">{index ? index : ''}</Table.Cell>
    <Table.Cell className="TYPE">{type}</Table.Cell>
    <Table.Cell className="NOTE">{note}</Table.Cell>
    <Table.Cell className="COST" data-prefix="$">
      {formatNumber.currency(cost || 0)}
    </Table.Cell>
  </Table.Row>
);

export type CustomPdfSubtotalRowProps = ComponentProps<typeof Table.Row> & {
  index?: number;
  subtotal?: number;
};

const CustomPdfSubtotalRow = ({ index, subtotal, ...props }: CustomPdfSubtotalRowProps): ReactElement => (
  <Table.Row {...props} className={getClasses('CustomPdfTable-SubtotalRow', props.className)}>
    {index > 0 && <Table.Cell className="COUNT">Total Items: {index}</Table.Cell>}
    <Table.Cell className="LABEL" colSpan={3}>
      SUB TOTAL:
    </Table.Cell>
    <Table.Cell className="SUBTOTAL" data-prefix="$">
      {formatNumber.currency(subtotal || 0)}
    </Table.Cell>
  </Table.Row>
);

export default CustomPdfTableRow;
